<template>
  <v-btn-toggle v-bind="$attrs" v-bind:value="value" v-on:change="$emit('change', $event)" :mandatory="noempty"
    :multiple="multiple" dense>
    <template v-for="(item, index) in list">
      <v-tooltip bottom :key="index + '-buttongroup-option'" :disabled="!item.text">
        <template v-slot:activator="{ on, attrs }">
          <v-btn :value="item.value !== undefined ? item.value : item.Id" v-bind="attrs" v-on="on" :small="dense"
            :color="backGroundColor(item)"
            style="min-width: 20px; min-height: 20px; border-color: rgba(0, 0, 0, 0.25) !important;">
            <v-icon v-if="item.icon" v-text="item.icon" :color="foreGroundColor(item)" size="18" />
            <div v-else v-text="item.text"
              :class="IsActive(item.value !== undefined ? item.value : item.Id) ? 'white--text' : ''"
              class="text-capitalize" />
          </v-btn>
        </template>
        <span v-text="translateIfKey(item.text)" />
      </v-tooltip>
    </template>
  </v-btn-toggle>
</template>


<script>
export default {
  name: "QButtonGroup",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    label: String,
    keyname: String,
    value: [Number, String, Array],
    list: Array,
    noempty: Boolean,
    multiple: Boolean,
    edit: Boolean,
    color: String,
    loading: Boolean,
    dense: Boolean,
    alwaysShowColor: Boolean,
  },
  components: {},

  data() {
    return {
      editValue: null
    };
  },

  mounted() { },

  methods: {
    IsActive(val) {
      var duplicate;
      if (!this.multiple) {
        duplicate = ("" + val) === ("" + this.value);
      }
      else if (this.value && this.value instanceof Array) {
        duplicate = this.value?.some(x => ("" + val) === ("" + x));
      }

      return duplicate;
    },

    foreGroundColor(val) {
      var active = this.IsActive(val.value !== undefined ? val.value : val.Id);
      if (this.alwaysShowColor || active) {
        return val.icon ? this.valueActiveColor(val) : 'white';
      }
      else {
        return 'black';
      }
    },

    backGroundColor(val) {
      var active = this.IsActive(val.value !== undefined ? val.value : val.Id);
      if (active) {
        return !val.icon ? this.valueActiveColor(val) : 'white';
      }
      else {
        return 'white';
      }
    },

    valueActiveColor(val) {
      if (val.color) {
        return val.color;
      }
      else if (this.color) {
        return this.color;
      }
      else {
        return 'primary';
      }
    },
  },

  computed: {},

  watch: {
    editValue: function () {
      this.$emit("fetch", { key: this.keyname, value: this.editValue });
    },
  },
};
</script>

<style scoped></style>